import { ENV } from "../Utils";

export class Post {
  baseApi = ENV.BASE_API;

  async createPost(accessToken, data) {
    try {
      data.miniature = data.file; // Asumiendo que `data.file` tiene la imagen para la miniatura

      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;

      const formData = new FormData();

      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));

      const url = `${this.baseApi}/${ENV.API_ROUTES.POST}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPosts(page = 1, limit = 10) {
    try {
      const pageFilter = `page=${page}`;
      const limitFilter = `limit=${limit}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.POSTS}?${pageFilter}&${limitFilter}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updatePost(accessToken, id, data) {
    try {
      if (data.miniature) {
        data.miniature = data.file;
      }
      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      const url = `${this.baseApi}/${ENV.API_ROUTES.POST}/${id}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deletePost(accessToken, id) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.POST}/${id}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPost(path) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.POST}/${path}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
